var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-table-3',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"table",attrs:{"data":_vm.items,"columns":_vm.columns,"actions":_vm.actions,"paginateFromApi":"","paginationApi":{
      currentPage: _vm.currentPage,
      pageSize: _vm.pageSize,
      total: _vm.totalItems
    }},on:{"update-page-size":_vm.handleChangePageSize,"update-current-page":_vm.handleChangeCurrentPage,"rtable-push-action":_vm.handleCommand}}),_c('RequestForm',{ref:"detail",attrs:{"append-to-body":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }